/// <amd-module name="VSSUI/Components/IdentityPickerDropdown/IdentityPickerDropdown" />

import * as React from "react";
import { IReadonlyObservableValue, ObservableLike, ObservableValue, useObservable } from "VSS/Core/Observable";
import { Observer } from "VSSUI/Observer";
import { CustomIdentityPickerDropdown } from "./CustomIdentityPickerDropdown";
import { IIdentityPickerDropdownProps } from "./IdentityPickerDropdown.Props";
import { IIdentity } from "./SharedIdentityPicker.Props";

export const IdentityPickerDropdown: React.FunctionComponent<IIdentityPickerDropdownProps> = (props: IIdentityPickerDropdownProps) => {
    const [textValue, setTextValue] = useObservable(getTextValue(props.value));
    const [suggestionsVisible, setSuggestionsVisible] = useObservable(false);
    const { onChange } = props;

    const suggestionsVisibleChanged = (opened: boolean) => {
        props.onSuggestionsVisibleChanged && props.onSuggestionsVisibleChanged(opened);
        setSuggestionsVisible(opened);
    };

    const onPersonaChange = (item?: IIdentity): boolean => {
        if (onChange(item) !== false) {
            setTextValue(item ? item.displayName || item.mailNickname : "");
            return true;
        } else {
            setTextValue("");
            return false;
        }
    };

    if (!ObservableLike.isObservable(props.value)) {
        React.useEffect(() => {
            setTextValue((props.value && ObservableLike.getValue(props.value) && ObservableLike.getValue(props.value)!.displayName) || "");
        }, [props.value]);
    }

    return (
        <Observer
            value={{
                observableValue: props.value,
                filter: () => {
                    setTextValue(getTextValue(props.value));
                    return false;
                }
            }}
        >
            {() => (
                <CustomIdentityPickerDropdown
                    {...props}
                    suggestionsVisible={suggestionsVisible}
                    onChange={onPersonaChange}
                    onInputChange={setTextValue}
                    onSuggestionsVisibleChanged={suggestionsVisibleChanged}
                    textValue={textValue}
                />
            )}
        </Observer>
    );
};

function getTextValue(value: IReadonlyObservableValue<IIdentity | undefined> | IIdentity | undefined) {
    return value && ObservableLike.getValue(value) ? ObservableLike.getValue(value).displayName : "";
}
